import { cn } from '../../lib/format.js';

const tones = {
  neutral: 'bg-sand text-ink',
  accent: 'bg-brand text-white',
  success: 'bg-success/10 text-success',
  danger: 'bg-danger/10 text-danger',
  outline: 'border border-mist bg-surface text-muted',
  solid: 'bg-noir text-white',
};

/**
 * Small status labels. Square, tracked capitals in the house face, so a label
 * reads in the same voice as the buttons beside it.
 */
export const Badge = ({ tone = 'neutral', className, children, ...props }) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 px-2 py-1 text-2xs leading-none font-semibold tracking-[0.08em] uppercase',
      tones[tone],
      className,
    )}
    {...props}
  >
    {children}
  </span>
);

export default Badge;
